import { state, error, result, Props, ControlPlane } from './symbols';
import { sign } from './utils';
export function getProps(model) {
    return model[Props];
}
export function getSign(model) {
    return sign(model[Props]);
}
export function getState(model) {
    return model[state];
}
export function getError(model) {
    return model[error];
}
export function getResult(model) {
    return model[result];
}
export function on(model, field, handler) {
    const ref = (next, prev) => {
        handler(next, prev);
    };
    return model[ControlPlane].subscribe(field, ref);
}
export function once(model, field, handler) {
    const ref = (next, prev) => {
        dispose();
        handler(next, prev);
    };
    const dispose = model[ControlPlane].subscribe(field, ref);
    return dispose;
}
export function set(model, data) {
    model[ControlPlane].set(data);
}
